import React from "react";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import theme from '../../theme';
import viberIcon from '../../assets/icons/viber.svg';

export function NewsletterSubscription() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const viberInviteLink =
    "https://invite.viber.com/?g2=AQANB5CH9mXPmlXpydBOADNepL6i6k7QbJSde2PLUla0eW8UDvsqqYHVg4RGSYR%2B";

  
  return (
    <Box
      component="section"
      sx={{
        backgroundColor: theme.palette.secondary.main,
        display: "flex",
        flexDirection: "column",
        width: isMobile ? "100%" : "100%",
        alignItems: "center",
        marginTop: isMobile ? "20px" : "40px",
        marginBottom: isMobile ? "20px" : "40px"
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          color: theme.palette.text.main,          
          marginBottom: isMobile ? "0.5rem" : "1rem",
          fontFamily: "Roboto, sans-serif",
          fontWeight: 600,
          lineHeight: "32px",
          textDecoration: "none",
          textUnderlinePosition: "from-font",
          textDecorationSkipInk: "none",
          fontSize: isMobile ? "1rem" : "1.5rem",
          padding: "1.5rem",
        }}
      >
        We're thrilled to have you here—please let us know if you need anything
        and everything!
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: isMobile ? "0.75rem" : "1rem",
          justifyContent: "center",
          width: isMobile ? "100%" : "50%",
          margin:"0px 5px 35px 5px",
          alignContent: "center",
          alignItems: "center",
          lineHeight: isMobile? "15px" : "27px",
        }}
      >
        <Button
          component="a"
          href={viberInviteLink}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            backgroundColor: "#7360f2",
            padding: isMobile ? "0.75rem 1.2rem" : "0.9rem 1.8rem",
            "&:hover": {
              backgroundColor: "#5a48e6",
            },
            width: isMobile ? "70%" : "55%",
            color: "#FFFFFF",
            fontFamily: "Inter, sans-serif",
            fontSize: "1rem",
            fontWeight: 600,
            textAlign: "center",
            textTransform: "none",
            borderRadius: "999px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            boxShadow: "0 12px 24px rgba(115, 96, 242, 0.25)",
          }}
        >
          <img src={viberIcon} alt="Viber" style={{ width: 18, height: 18 }} />
          Join our Viber Channel
        </Button>
      </Box>
    </Box>
  );
}
